export const PAGINATION = Object.freeze({
  defaultPageSize: 15,
  pageSizeOptions: [10, 15, 25, 50, 100],
});
